var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5C14.9821 17.5 17.2171 16.8012 18.8468 15.9569C19.3941 15.6734 19.892 15.3637 20.3195 15.0431C21.3597 15.5616 22 16.3379 22 17.5C22 21 16.1923 21 11.1429 21C6.0934 21 2 18.5 2 17.5C2 17.1466 2.51116 16.6059 3.39504 16.0544C4.10553 16.5309 4.93136 16.8263 5.74305 17.0211C7.73976 17.5003 10.2594 17.5002 12.3869 17.5H12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5143 12.5C14.3141 12.5 15.9283 11.9733 17.1056 11.3379C17.5812 11.0813 18.0125 10.7925 18.3702 10.4886C19.692 11.2117 20.5 12.025 20.5 12.5C20.5 13.5 16.9183 16 12.5 16C8.08172 16 3 16 3 12.5C3 11.2169 3.68292 10.4042 4.76573 9.88947C4.94589 10.3237 5.21495 10.7098 5.56447 11.0383C6.20144 11.637 7.01038 11.956 7.75717 12.1427C9.18831 12.5006 10.9698 12.5003 12.4062 12.5H12.5143Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5C15 4.92857 13.772 6 12.2571 6C10.7423 6 9 6 9 4.5C9 3 10.7423 3 12.2571 3C13.772 3 15 4.07143 15 4.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2571 7.50009C13.36 7.50009 14.3246 7.115 15.012 6.66987C15.1021 6.61148 15.1902 6.55033 15.2756 6.48675C16.9051 7.06851 18 8.02307 18 8.49998C18 9.21427 15.544 11 12.5143 11C9.48461 11 6 11 6 8.49998C6 7.24741 6.87474 6.62241 8.12874 6.31055C8.14339 6.32796 8.15831 6.34524 8.1735 6.36237C8.60961 6.85428 9.16093 7.10875 9.62944 7.24932C10.4703 7.50159 11.4756 7.50073 12.1624 7.50015L12.2571 7.50009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZen);
export default __webpack_public_path__ + "static/media/zen.2a863fa0ef148afb8b5e541de75172df.svg";
export { ForwardRef as ReactComponent };